import { render, staticRenderFns } from "./MenuInsightQuestion.vue?vue&type=template&id=12b6cc11&"
import script from "./MenuInsightQuestion.vue?vue&type=script&lang=js&"
export * from "./MenuInsightQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerGears});
